module.exports = __webpack_public_path__ + "img/image (118).15f2c2d5.jpg";